<template lang="pug">
v-app(id='app')
  v-app-bar(app, flat, absolute, height='80', color='primary')
    v-card(flat, tile, width='960', color='primary', class='mx-auto pt-6')
      v-row(justify='space-between', class='ma-0')
        v-toolbar-title(@click='$router.push("/")', style='cursor:pointer')
          v-img(src='/logo.png', height='36', width='136', alt='Koos Workplace', contain, position='left')
        v-spacer
        v-btn(depressed, outlined, color='white', href='https://www.jtechs.com/#sec-inquiry', class="mr-3") Inquiries
        v-btn(depressed, outlined, color='white', href='https://www.jtechs.com/japan/#sec-inquiry') お問い合わせ

  v-content
    router-view(:key='$route.fullPath')
</template>

<script>
import Param from "@/lib/definition/variables";

export default {
  name: 'App',
  components: {
  },
  data: () => ({
  }),
  computed: {
    isWWW: { get () {  
      var host = window.location.host
      if (host.includes('www.')) { return true }
      if (site.routerType === 'www') { return true }
      return false
    }},
  },
  mounted () {
  },
  methods: {
  }
};
</script>

<style lang='scss'>
.v-application {
  font-family: "Helvetica Neue", Arial, "Hiragino Kaku Gothic ProN", "Hiragino Sans", Meiryo, sans-serif !important;
  font-size: 16px;
  line-height: 1.7rem !important;
  letter-spacing: .04rem;
}
</style>
